import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoTaller from "../taller/InfoTaller";
const Footer = lazy(() => import('../footer/Footer'));
function Taller() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Hyundai cuenta con una gran red de talleres a nivel nacional. Revisa la ubicación e información relevante de todos nuestros puntos de servicio"
        />
        <meta
          name="keywords"
          content="Talleres Hyundai, Talleres, red de servicio, servicio Hyundai"
        />
        <title>Red de Talleres Hyundai</title>
      </Helmet>
      <Menu />
      <InfoTaller />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Taller;